import { MediaInfo, BitrateInfo } from 'dashjs';
import {
    IAudioTrack,
    ITextTrack,
    IVideoTrack,
    ITrack,
    TrackKind,
    TrackType,
} from '@24i/player-base';

export function isTrackSelected(
    track: MediaInfo,
    currentTrack: MediaInfo
): boolean {
    return (
        (typeof track.id !== 'undefined' &&
            typeof currentTrack.id !== 'undefined' &&
            track.id === currentTrack.id) ||
        (typeof track.index !== 'undefined' &&
            typeof currentTrack.index !== 'undefined' &&
            track.index === currentTrack.index)
    );
}

function mapToTrack(
    track: MediaInfo,
    currentTrack?: MediaInfo
): Omit<ITrack, 'type'> {
    const { id, index, roles = [], labels = [], lang } = track;
    return {
        id: `${id || index}`,
        kind: (roles[0] as TrackKind) || TrackKind.Undefined,
        label: labels[0],
        language: lang || 'default',
        default: undefined,
        selected: currentTrack && isTrackSelected(track, currentTrack),
        extra: track,
    };
}

export function mapToAudioTrack(
    track: MediaInfo,
    currentTrack?: MediaInfo
): IAudioTrack {
    const { audioChannelConfiguration = [], bitrateList = [] } = track;
    return {
        ...mapToTrack(track, currentTrack),
        bitrate: bitrateList[0]?.bandwidth,
        channels: parseInt(audioChannelConfiguration[0], 10) || undefined,
        type: TrackType.Audio,
    };
}

export function mapToTextTrack(
    track: MediaInfo,
    currentTrack?: MediaInfo
): ITextTrack {
    return {
        ...mapToTrack(track, currentTrack),
        forced: false,
        type: TrackType.Text,
    };
}

export function mapToVideoTrack(track: BitrateInfo): IVideoTrack {
    return {
        id: String(track.qualityIndex),
        kind: TrackKind.Variant,
        label: `${track.height}p`,
        height: track.height,
        width: track.width,
        bitrate: track.bitrate,
        type: TrackType.Video,
        selected: false,
        frameRate: 0,
        default: undefined,
    };
}